import React from 'react';
import { getPartnersCustomTrackingMeta } from 'helpers/partnerCustomParamsHelper';
import { TabbedContainer, TabPane } from 'components/TabbedContainer';
import OtherModule from 'partial/OfferManager/modules/ModuleRepository/OtherModule';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import classnames from 'classnames';

const TabbedModuleView = props => {
  const { CustomModuleRepository } = props;
  let showHeader = true;
  let finalModuleList = props.moduleList ? props.moduleList : { modules: [] };

  if (props.moduleToShow) {
    finalModuleList.modules = finalModuleList.modules.filter(
      m =>
        (Array.isArray(props.moduleToShow) &&
          props.moduleToShow.indexOf(m.module) >= 0) ||
        m.module === props.moduleToShow,
    );
    showHeader = false;
  }

  let partnersCustomTrackingMeta = props.partnersCustomTrackingMeta
    ? props.partnersCustomTrackingMeta
    : getPartnersCustomTrackingMeta(finalModuleList);

  return (
    <TabbedContainer
      defaultActiveKey={props?.defaultActiveKey}
      onTabClick={props.onTabClick}
      destroyInactiveTabPane
      onChange={props?.onChange}
      activeKey={props.selectedTab}
    >
      {finalModuleList.modules.map((m, k) => {
        //Overide Module level partners meta
        //applicable for Action Modules created in actions_etl
        partnersCustomTrackingMeta = m.partnersCustomTrackingMeta
          ? m.partnersCustomTrackingMeta
          : partnersCustomTrackingMeta;

        const tabName = m.tabName ?? `Tab ${k}`;
        const tabKey = m.tabKey ?? k;
        if (CustomModuleRepository) {
          return (
            <TabPane tab={tabName} key={tabKey}>
              <CustomModuleRepository
                {...m}
                key={m.module}
                modulePosition={k + 1}
                module={m.module}
                offers={m.offers}
                vertical={m.vertical}
                containerType={m.module}
                currentLoanDetails={m.currentLoanDetails}
                showHeader={showHeader}
                {...props}
                partnersCustomTrackingMeta={partnersCustomTrackingMeta}
                isPersonalLoanCarousel={props.isPersonalLoanCarousel}
                isDefaultModuleViewDisabled={props?.isDefaultModuleViewDisabled}
              />
            </TabPane>
          );
        } else {
          return (
            <TabPane tab={tabName} key={tabKey}>
              <OtherModule
                {...m}
                key={m.module}
                modulePosition={k + 1}
                module={m.module}
                offers={m.offers}
                vertical={m.vertical}
                containerType={m.module}
                currentLoanDetails={m.currentLoanDetails}
                showHeader={showHeader}
                {...props}
                partnersCustomTrackingMeta={partnersCustomTrackingMeta}
                isPersonalLoanCarousel={props.isPersonalLoanCarousel}
                isDefaultModuleViewDisabled={props?.isDefaultModuleViewDisabled}
              />
            </TabPane>
          );
        }
      })}
    </TabbedContainer>
  );
};

const LinearModuleView = props => {
  const { CustomModuleRepository, gapClass } = props;
  let showHeader = true;
  let finalModuleList = props.moduleList ? props.moduleList : { modules: [] };

  if (props.moduleToShow) {
    finalModuleList.modules = finalModuleList.modules.filter(
      m =>
        (Array.isArray(props.moduleToShow) &&
          props.moduleToShow.indexOf(m.module) >= 0) ||
        m.module === props.moduleToShow,
    );
    showHeader = false;
  }

  let partnersCustomTrackingMeta = props.partnersCustomTrackingMeta
    ? props.partnersCustomTrackingMeta
    : getPartnersCustomTrackingMeta(finalModuleList);

  const ModuleViewClass = classnames(`inner flex-column ${gapClass}`);

  return (
    <FlexContainer className={ModuleViewClass}>
      {finalModuleList.modules.map((m, k) => {
        //Overide Module level partners meta
        //applicable for Action Modules created in actions_etl
        partnersCustomTrackingMeta = m.partnersCustomTrackingMeta
          ? m.partnersCustomTrackingMeta
          : partnersCustomTrackingMeta;
        if (CustomModuleRepository) {
          return (
            <CustomModuleRepository
              {...m}
              key={m.module}
              modulePosition={k + 1}
              module={m.module}
              offers={m.offers}
              vertical={m.vertical}
              containerType={m.module}
              currentLoanDetails={m.currentLoanDetails}
              showHeader={showHeader}
              {...props}
              partnersCustomTrackingMeta={partnersCustomTrackingMeta}
              isPersonalLoanCarousel={props.isPersonalLoanCarousel}
              isDefaultModuleViewDisabled={props?.isDefaultModuleViewDisabled}
              extraAttributes={props.extraAttributes}
            />
          );
        } else {
          return (
            <OtherModule
              {...m}
              key={m.module}
              modulePosition={k + 1}
              module={m.module}
              offers={m.offers}
              vertical={m.vertical}
              containerType={m.module}
              currentLoanDetails={m.currentLoanDetails}
              showHeader={showHeader}
              {...props}
              partnersCustomTrackingMeta={partnersCustomTrackingMeta}
              isPersonalLoanCarousel={props.isPersonalLoanCarousel}
              isDefaultModuleViewDisabled={props?.isDefaultModuleViewDisabled}
            />
          );
        }
      })}
    </FlexContainer>
  );
};

const ModuleView = props => {
  if (props.moduleView === 'tabs') {
    return <TabbedModuleView {...props} />;
  } else {
    return <LinearModuleView {...props} />;
  }
};

export default ModuleView;
